import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["type", "page"]
  static values = {
    baseUrl: String,
    queryParams: String
  }

  generate() {
    const type = this.typeTarget.value
    const offset = this.pageTarget.value
    const url = `${this.baseUrlValue}${type}${this.queryParamsValue}&offset=${encodeURIComponent(offset)}`

    window.location.href = url
  }
}
